import { STARZ, STARZPLAY } from "./concurrencyUtils";

const GUEST_PROFILE_TYPE = "EV";

/**
 * Gets cookie value for a given cookie name from the browser.
 * @param {String} name - Cookie name.
 * @returns {String} Cookie value.
 * @public
 */
export function getCookieByName(name) {
  const value = "; " + document.cookie;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2)
    return parts
      .pop()
      .split(";")
      .shift();
}
export function deleteCookie(cookieName) {
  document.cookie = cookieName + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}

export function generateRandomNumber() {
  const charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < 20; i++) {
    const randomIndex = Math.floor(Math.random() * charset.length);
    result += charset.charAt(randomIndex);
  }

  return result;
}

export function base64Decode(encodedString) {
  return encodedString && atob(encodedString);
}

export function resetGuestProfileType(appState) {
  return (appState.currentProfileType = GUEST_PROFILE_TYPE);
}

export function guestProfie() {
  let guestProfile = getCookieByName("guest-profile");
  guestProfile = guestProfile && base64Decode(guestProfile);
  guestProfile = (guestProfile && JSON.parse(guestProfile)) || {};
  return guestProfile;
}

export async function urlParamsEncode(params) {
  if (params && Object.keys(params).length > 0) {
    return Object.entries(params)
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join("&");
  }
  return params;
}

export function makeBaseContentAsStarzplay(addonContent) {
  if (!addonContent || addonContent === STARZ) {
    return STARZPLAY;
  }
  return addonContent;
}
